module.exports = __webpack_public_path__ + "static/media/notfound.0ee7ae1a.png";